/* tslint:disable */
/* eslint-disable */
/**
 * Ак Барс Недвижимость API
 * Инструменты разработчика:  [ [Документация API. Swagger](/docs/) ]  [ [Документация API. Redoc](/redoc/) ] [ [Панель администрирования](/admin/) ] [ [Документация Image-Service](/api/attachments/docs/) ]
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';

/**
 * 
 */
export class ExternalApi extends runtime.BaseAPI {

    /**
     */
    async externalV1AmoWebHookCreateRaw(): Promise<runtime.ApiResponse<void>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-App-Version"] = this.configuration.apiKey("X-App-Version"); // AppVersion authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-Device-Id"] = this.configuration.apiKey("X-Device-Id"); // DeviceId authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-Device-Type"] = this.configuration.apiKey("X-Device-Type"); // DeviceType authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-Os-Version"] = this.configuration.apiKey("X-Os-Version"); // OsVersion authentication
        }

        const response = await this.request({
            path: `/external/v1/amo-web-hook/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async externalV1AmoWebHookCreate(): Promise<void> {
        await this.externalV1AmoWebHookCreateRaw();
    }

    /**
     */
    async externalV1AmoWebHookListRaw(): Promise<runtime.ApiResponse<void>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-App-Version"] = this.configuration.apiKey("X-App-Version"); // AppVersion authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-Device-Id"] = this.configuration.apiKey("X-Device-Id"); // DeviceId authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-Device-Type"] = this.configuration.apiKey("X-Device-Type"); // DeviceType authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-Os-Version"] = this.configuration.apiKey("X-Os-Version"); // OsVersion authentication
        }

        const response = await this.request({
            path: `/external/v1/amo-web-hook/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async externalV1AmoWebHookList(): Promise<void> {
        await this.externalV1AmoWebHookListRaw();
    }

    /**
     */
    async externalV1SenseiWebHookCreateRaw(): Promise<runtime.ApiResponse<void>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-App-Version"] = this.configuration.apiKey("X-App-Version"); // AppVersion authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-Device-Id"] = this.configuration.apiKey("X-Device-Id"); // DeviceId authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-Device-Type"] = this.configuration.apiKey("X-Device-Type"); // DeviceType authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-Os-Version"] = this.configuration.apiKey("X-Os-Version"); // OsVersion authentication
        }

        const response = await this.request({
            path: `/external/v1/sensei-web-hook/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async externalV1SenseiWebHookCreate(): Promise<void> {
        await this.externalV1SenseiWebHookCreateRaw();
    }

    /**
     */
    async externalV1SenseiWebHookListRaw(): Promise<runtime.ApiResponse<void>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-App-Version"] = this.configuration.apiKey("X-App-Version"); // AppVersion authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-Device-Id"] = this.configuration.apiKey("X-Device-Id"); // DeviceId authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-Device-Type"] = this.configuration.apiKey("X-Device-Type"); // DeviceType authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-Os-Version"] = this.configuration.apiKey("X-Os-Version"); // OsVersion authentication
        }

        const response = await this.request({
            path: `/external/v1/sensei-web-hook/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async externalV1SenseiWebHookList(): Promise<void> {
        await this.externalV1SenseiWebHookListRaw();
    }

}
